import type { ConnectedProjectDto } from "@/api/types";

export function hasAdminProject(projects: readonly Pick<ConnectedProjectDto, "userRole">[] | undefined): boolean {
  return projects?.some((project) => project.userRole !== "resident") ?? false;
}
